import { HStack } from "@/components/ui/hstack";
import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Link as ExpoLink } from "expo-router";
import { Link } from "@/components/ui/link";
import { cn } from "@gluestack-ui/nativewind-utils/cn";
import { TabLayoutProps } from "../dashboard/tab.layout";
import { useQRBadgeState } from "@/utils/useQRBadgeState";
import { Box } from "@/components/ui/box";

export type WebSidebarProps = Omit<TabLayoutProps, "children">;

export function WebSidebar({
  descriptors,
  state,
  navigation,
}: WebSidebarProps) {
  const hasQRBadge = useQRBadgeState();

  const tabs = Object.entries(descriptors).filter(
    ([_, d]) =>
      d.options.tabBarItemStyle === undefined ||
      (d.options.tabBarItemStyle as any).display !== "none"
  );

  return (
    <VStack className="pl-8 py-4 pr-4 h-full border-r border-border-300 justify-between">
      <VStack className="gap-2">
        {tabs.map(([key, d], index) => {
          const TabBarIcon = d.options.tabBarIcon;
          const isActive = state.index === index;
          return (
            <Link
              className={cn([
                "flex flex-row gap-3 items-center hover:bg-background-50 p-2 rounded-md",
                { "bg-background-100": isActive },
              ])}
              key={key}
              href={`/${d.route.name}`}
              onPress={(e) => {
                e?.preventDefault();

                const newRoutes = state.routes.map((r) => {
                  if (r.key === d.route.key) {
                    return {
                      ...r,
                      state: {
                        index: 0,
                        routes: [{ name: "index" }],
                      },
                    };
                  }
                  return {
                    ...r,
                  };
                });

                navigation.reset({
                  index: index,
                  routes: newRoutes as any,
                });
              }}
            >
              {TabBarIcon && (
                <TabBarIcon focused={isActive} color="black" size={10} />
              )}
              {typeof d.options.tabBarLabel === "string" ? (
                <Text
                  className={
                    isActive ? "text-typography-900" : "text-typography-400"
                  }
                >
                  {d.options.tabBarLabel}
                </Text>
              ) : (
                <Text>Not supported</Text>
              )}
              {hasQRBadge && d.route.name === "qrs" && (
                <Box className="bg-red-500 w-2 h-2 rounded-full" />
              )}
            </Link>
          );
        })}
      </VStack>
      <VStack className="gap-1 text-xs">
        <ExpoLink href="https://gotips.co/terms-of-use/" target="_blank">
          <Text className="text-xs">Terms of use</Text>
        </ExpoLink>
        <ExpoLink href="https://gotips.co/privacy-policy/" target="_blank">
          <Text className="text-xs">Privacy policy</Text>
        </ExpoLink>
        <HStack className="mt-1">
          <Text className="text-xs">© {new Date().getFullYear()} </Text>
          <ExpoLink href="https://gotips.co/" target="_blank">
            <Text className="text-xs font-bold">Hoteza Tips</Text>
          </ExpoLink>
        </HStack>
      </VStack>
    </VStack>
  );
}
